import { render } from "./BasicInformation.vue?vue&type=template&id=64d1d7ec&scoped=true"
import script from "./BasicInformation.vue?vue&type=script&lang=js"
export * from "./BasicInformation.vue?vue&type=script&lang=js"

import "./BasicInformation.vue?vue&type=style&index=0&id=64d1d7ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d1d7ec"]])

export default __exports__